export default "__VITE_ASSET__CFc0BqgX__"